import React, {useState, useEffect } from 'react'

import { Accordion} from 'react-bootstrap';

import ShowMessages from '../../components/Exceptions';
import loadingButton  from '../../pages/layouts/Buttons'
import api from '../../services/api';
import ModalLead from './../../pages/modals/modal-lead';
import Loading from '../../components/Loading';
import WHATSAPP from './../../assets/whatsapp.png'
import {format} from 'date-fns'
import {differenceInTime, PopulateConversation} from './../../components/Utils'
import { useChatData } from './../../components/messageView/chatContext'

const LeadData = ({data}) => {
    const [loading, setLoading]                   = useState(false)
    const [tag, setTag]                           = useState('')
    const [description, setDescription]           = useState('')
    const [tags, setTags]                         = useState([])
    const [dataTag, setDataTag]                   = useState([])
    const [annotations, setAnnotations]           = useState('')
    const [showModalLead, setShowModalLead]       = useState(false)
    const [dataLead, setDataLead]                 = useState([])
    const [idpeople,setIDPeople]                  = useState(0)
    const [editState, setEditState]               = useState(false)
    const [dataInteractions, setDataInteractions] = useState([])

    const { setConversation }      = useChatData()

    const handleCloseModalLeads  = () => {setShowModalLead(false)}

    const addTag = () => {
        const tagAlreadyExistInArrayTags = tags.some((item) => {
            if(item.tag === tag) {
                return true
            }
            return false;
        })

        if(tag.length === 0){
            ShowMessages({status : 500, message : "Tag não informada"})
            return
        }

        if(tags.length >= 5){
            ShowMessages({status : 500, message : "Permitido apenas 5 tags"})
            return
        }

        if(tagAlreadyExistInArrayTags){
            ShowMessages({status : 500, message : "Tag já existe"})
            return
        }

        setTags([...tags, {tag, description}]);
    };

    const removeTag = (_tag) => {
        let arrayOfTags = tags.filter((item) => {
            return item.tag !== _tag;
        })

        setTags(arrayOfTags);
    }

    const handleSubmit = async(event) => {
        loadingButton(true,document.querySelector('#submit-people-annotation'),document.querySelector('#submit-people-annotation').children[0].classList,document.querySelector('#submit-people-annotation').lastChild.nodeValue)
        event.preventDefault()

        try {
            await api.post('/attendance/annotation',{to       : data.to.replace(/[\W_,[a-z]+/g,""),
                                                     name     : data.name,
                                                     idpeople : data.idpeople,
                                                     tags     : tags,
                                                     idmessagehistoryheader : data.idmessagehistoryheader,
                                                     annotations })
                     .then((response) => {
                        loadingButton(false,document.querySelector('#submit-people-annotation'),'fa fa-save','Salvar')

                     })
                    .catch((error) => {
                        ShowMessages(error)
                        loadingButton(false,document.querySelector('#submit-people-annotation'))
                    })
        } catch (response) {
            loadingButton(false,document.querySelector('#submit-people-annotation'))
            ShowMessages(response)
        }
    }

    const EditLead = async() => {
        await api.get('/leads/' + idpeople)
                 .then(response => {
                    let _lead = response.data
                    setEditState(true)
                    if (!_lead) {
                        setEditState(false)
                        _lead = {}

                        if (data.to.length === 12)
                            _lead.phones = data.to.substring(0,4) + '9' + data.to.substring(4,12)
                        else
                            _lead.phones = data.to
                    }

                    setDataLead(_lead)
                    setShowModalLead(true)
                 })
                 .catch( error => {
                    ShowMessages(error)
                 })
    }

    const handleChat = async(e,idautomationchatheadhistory) => {
        try {
            await api.post('/showAttendance',{id : idautomationchatheadhistory})
                     .then(response => {
                        let _message = []
                        console.log(response.data)
                        response.data.map(_item => {
                            _message.push(PopulateConversation(_item,_item.isreceive))
                        })

                        setConversation(_message)
                     })
                     .catch(e => {
                        console.log(e)
                     })
        } catch(e) {
            console.log(e)
        }
    }

    useEffect(() => {
        const getTags = async () => {
            setLoading(true) // Inicia o loading antes de iniciar as requisições

            try {
                const [annotationsResponse, chatListResponse] = await Promise.all([
                    api.post('/getAnnotations', { to: data.to.toString().replace(/[\W_,[a-z]+/g, "") }),
                    api.post('/getChatListforUser', { to: data.to.toString().replace(/[\W_,[a-z]+/g, "") }),
                ]);

                setDataTag(annotationsResponse.data.tags);
                setAnnotations(annotationsResponse.data?.annotation?.annotations);
                setIDPeople(annotationsResponse.data.annotation?.idpeople || 0);

                let _tag = annotationsResponse.data?.annotation?.tags;
                if (_tag) {
                    setTags(typeof _tag === 'object' ? _tag : JSON.parse(annotationsResponse.data.annotation?.tags));
                } else {
                    setTags([]);
                }

                // Tratamento da segunda requisição
                setDataInteractions(chatListResponse.data);

            } catch (error) {
                ShowMessages(error);
            } finally {
                setLoading(false); // Finaliza o loading quando ambas as requisições terminarem
            }
        };

        getTags();
    }, []);


    return (
        <aside className="sidebar" style={{ padding: "10px", gap: "5px", display: "flex", flexDirection: "column", overflow: "hidden", width: "330px" }}>
            {loading ? (
                <Loading loading={loading}/>
            ) : (
                    <>
                        {showModalLead && <ModalLead showModal={showModalLead} handleCloseModal={handleCloseModalLeads} editState={editState} data={dataLead} copy={false} />}
                        <div style={{ display: 'flex', justifyContent: "space-between" }}>
                            <button id='submit-people-lead' className={`btn btn-warning ${loading ? "hidden" : ""}`} onClick={e => EditLead()}>
                                <em className="fa fa-edit"></em> Dados do Lead
                            </button>
                            <button id='submit-people-annotation' className={`btn btn-primary ${loading ? "hidden" : ""}`} onClick={e => handleSubmit(e)}>
                                <em className="fa fa-save"></em> Salvar Alterações
                            </button>
                        </div>

                        <div >
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header className="own-acordion">
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <i className='fa fa-tags' />
                                            <span className="w-100">Etiquetas</span>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body className="p-0" style={{ height: "250px", overflow: "auto" }}>
                                        <div style={{ display: "flex", gap: "5px", padding: "10px" }}>
                                            <div style={{ width: "350px" }}>
                                                <label>Etiquetas</label>
                                                <select className='form-select' value={tag} onChange={e => {
                                                    setTag(e.target.value)
                                                    setDescription(e.target.options[e.target.selectedIndex].text)
                                                }}>
                                                    <option value=''>Selecione</option>
                                                    {dataTag.map(_item => {
                                                        return <option value={_item.idtag}>{_item.tag}</option>
                                                    })}
                                                </select>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "end" }}>
                                                <button className='btn btn-success' type="button" onClick={e => addTag(e)}><i className='fa fa-plus'></i></button>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: "5px", padding: "10px" }}>
                                            <table className="table table-striped w-100">
                                                <thead className="thead-theme">
                                                    <tr>
                                                        <th className='head-th'>Etiqueta</th>
                                                        <th className='head-th' style={{ textAlign: "center" }}>...</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tags.map((_actions, id) => {
                                                        return (<tr className="gradeX" key={id}>
                                                            <td style={{ verticalAlign: "middle" }}>{_actions.description}</td>
                                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                <button type='button' className="btn btn-danger btn-sm" onClick={e => removeTag(_actions.tag)}><i className="fa fa-trash" /></button>
                                                            </td>
                                                        </tr>)
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1" style={{ marginTop: "5px" }}>
                                    <Accordion.Header className="own-acordion">
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <i className='fa fa-file' />
                                            <span className="w-100">Observações</span>
                                        </div>

                                    </Accordion.Header>
                                    <Accordion.Body className="p-0" style={{ height: "250px", overflow: "auto" }}>
                                        <div style={{ display: "flex", gap: "5px", padding: "10px", flexDirection: "column" }}>
                                            <label>Observações</label>
                                            <textarea className='form-control' rows={10} value={annotations} onChange={e => setAnnotations(e.target.value)} />
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            {[6].includes(data.modeType) && (
                                <div style={{ display: "flex", flexDirection: "column", height: "75vh" }}>
                                    <div style={{ marginTop: "15px", background: "#86b3f3d5", justifyContent: "center", display: "flex", padding: "5px", marginBottom: "5px" }}>
                                        <span style={{ fontWeight: "bold", color: "#fff" }}>Minhas Últimas Interações</span>
                                    </div>
                                    <div style={{ display: "flex", gap: "5px", flexDirection: "column", height: "100%", overflow: "auto" }}>
                                        {dataInteractions.map(_item => (
                                            <div className='btn-chat-history box-shadow' onClick={e => handleChat(e,_item.idautomationchatheadhistory)}>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "60px", height: "70px" }}>
                                                    <img src={WHATSAPP} alt="Whatsapp" style={{ width: "50px" }} />
                                                </div>
                                                <div style={{ fontSize: "12px" }}>
                                                    <div>
                                                        <span style={{ fontWeight: "bold" }}>Protocolo: </span>
                                                        <span>#{_item.idautomationchatheadhistory}</span>
                                                    </div>
                                                    <div>
                                                        <span style={{ fontWeight: "bold" }}>Inicializado em: </span>
                                                        <span>{_item.starthuman && format(_item.starthuman,'dd/MM/yyyy HH:mm:ss')}</span>
                                                    </div>
                                                    <div>
                                                        <span style={{ fontWeight: "bold" }}>Finalizado em: </span>
                                                        <span>{_item.endhuman && format(_item.endhuman,'dd/MM/yyyy HH:mm:ss')}</span>
                                                    </div>
                                                    <div>
                                                        <span style={{ fontWeight: "bold" }}>Duração: </span>
                                                        <span>{_item.starthuman && _item.endhuman && differenceInTime(_item.starthuman,_item.endhuman)}</span>
                                                    </div>
                                                </div>

                                            </div>
                                        ))}
                                        {dataInteractions.length <= 0 && (
                                            <div className='alert alert-warning' style={{padding:"15px", borderRadius:"5px", display:"flex", justifyContent:"center", alignItems:"center", gap:"5px"}}>
                                                <i className='fa fa-exclamation-triangle' style={{fontSize:"16px"}}/>
                                                <span>Você não possui interações</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
               )}
        </aside>

    )
};

export default LeadData;
